import { Component, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from '../../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';
import { FloatMaskInputComponent } from '../../float-mask-input/float-mask-input.component';

@Component({
  selector: 'bis-float-mask-input-keypad',
  templateUrl: './float-mask-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class FloatMaskInputKeypadComponent extends FloatMaskInputComponent {
  
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
     super(formulaireService, libelleService, filtreService, modeRenduService);
   }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }
}